var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7161 24.2924C25.809 24.3854 25.8827 24.4957 25.933 24.6171C25.9833 24.7384 26.0092 24.8686 26.0092 24.9999C26.0092 25.1313 25.9833 25.2614 25.933 25.3828C25.8827 25.5042 25.809 25.6145 25.7161 25.7074C25.6232 25.8004 25.5129 25.8741 25.3915 25.9243C25.2701 25.9746 25.14 26.0005 25.0086 26.0005C24.8772 26.0005 24.7471 25.9746 24.6257 25.9243C24.5043 25.8741 24.394 25.8004 24.3011 25.7074L16.0086 17.4137L7.71611 25.7074C7.52847 25.8951 7.27398 26.0005 7.00861 26.0005C6.74325 26.0005 6.48875 25.8951 6.30111 25.7074C6.11347 25.5198 6.00806 25.2653 6.00806 24.9999C6.00806 24.7346 6.11347 24.4801 6.30111 24.2924L14.5949 15.9999L6.30111 7.70745C6.11347 7.5198 6.00806 7.26531 6.00806 6.99995C6.00806 6.73458 6.11347 6.48009 6.30111 6.29245C6.48875 6.1048 6.74325 5.99939 7.00861 5.99939C7.27398 5.99939 7.52847 6.1048 7.71611 6.29245L16.0086 14.5862L24.3011 6.29245C24.4888 6.10481 24.7432 5.99939 25.0086 5.99939C25.274 5.99939 25.5285 6.1048 25.7161 6.29245C25.9038 6.48009 26.0092 6.73458 26.0092 6.99995C26.0092 7.26531 25.9038 7.5198 25.7161 7.70745L17.4224 15.9999L25.7161 24.2924Z",
    fill: "#19191C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d31a904202f7e97cc617b290fbc97643.svg";
export { ForwardRef as ReactComponent };